var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle-sharp",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39368",
    "data-name": "Path 39368",
    d: "M19.5,4.5a15,15,0,1,0,15,15A15.017,15.017,0,0,0,19.5,4.5Zm6.247,19.615-1.632,1.632L19.5,21.132l-4.615,4.615-1.632-1.632L17.868,19.5l-4.615-4.615,1.632-1.632L19.5,17.868l4.615-4.615,1.632,1.632L21.132,19.5Z",
    fill: "#ff5b3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleSharp);
export default __webpack_public_path__ + "static/media/close-circle-sharp.ec245bab18fd227c7dff55ee0e13f777.svg";
export { ForwardRef as ReactComponent };